/* istanbul ignore file */

import { DateTime } from 'luxon';
import type { DateRangeInputModel, RadioButtonsInputModel } from '@libs/form/models';
import type { RadioButtonsOptionModel } from '@libs/shared/models';

export type OrderHistorySortByValueType =
  '-create'
  | 'create'
  | '-delivery'
  | 'delivery'
  | 'gross'
  | '-gross'
  | 'net'
  | '-net';
export type OrderHistorySortByColumnType = 'createDate' | 'deliveryDate' | 'totalGross' | 'totalNet';
export type OrderHistorySortByDirectionType = 'asc' | 'desc';
export type OrderHistoryDeliveryType = 'complete' | 'partial';

export interface OrderHistoryFilter {
  delivery?: OrderHistoryDeliveryType;
  shipping?: {
    from?: DateTime;
    to?: DateTime;
  };
  order?: {
    from?: DateTime;
    to?: DateTime;
  };
}

export interface OrderHistoryFilterSortPageModel {
  page: number;
  limit: number;
  sort: OrderHistorySortByValueType;
  filter: OrderHistoryFilter;
}

export interface OrderHistorySortByModel {
  label: string;
  value: OrderHistorySortByValueType;
  column: OrderHistorySortByColumnType;
  direction: OrderHistorySortByDirectionType;
}

export const OrderHistorySortByOptions: OrderHistorySortByModel[] = [
  { label: 'neueste Bestellung', value: '-create', column: 'createDate', direction: 'desc' },
  { label: 'älteste Bestellung', value: 'create', column: 'createDate', direction: 'asc' },
  { label: 'neueste Lieferung', value: '-delivery', column: 'deliveryDate', direction: 'desc' },
  { label: 'älteste Lieferung', value: 'delivery', column: 'deliveryDate', direction: 'asc' },
  { label: 'Brutto absteigend', value: '-gross', column: 'totalGross', direction: 'desc' },
  { label: 'Brutto aufsteigend', value: 'gross', column: 'totalGross', direction: 'asc' },
  { label: 'Netto absteigend', value: '-net', column: 'totalNet', direction: 'desc' },
  { label: 'Netto aufsteigend', value: 'net', column: 'totalNet', direction: 'asc' },
];

export const OrderHistorySortBy: RadioButtonsInputModel = {
  type: 'radioButtons',
  name: 'sort',
  label: 'Sortieren nach',
  defaultValue: '-create',
  value: '-create',
  options: OrderHistorySortByOptions,
};

export const OrderHistoryOrderDate: DateRangeInputModel = {
  type: 'dateRange',
  name: 'orderDate',
  label: 'Bestelldatum',
  subscriptSizing: 'dynamic',
  value: {
    start: null,
    end: null,
  },
  defaultValue: {
    start: null,
    end: null,
  },
};

export const OrderHistoryShippingDate: DateRangeInputModel = {
  type: 'dateRange',
  name: 'shippingDate',
  label: 'Lieferdatum',
  subscriptSizing: 'dynamic',
  value: {
    start: null,
    end: null,
  },
  defaultValue: {
    start: null,
    end: null,
  },
};

export const OrderHistoryDeliveryOptions: RadioButtonsOptionModel[] = [
  {
    value: '',
    label: 'Alle',
  },
  {
    value: 'complete',
    label: 'vollständige Lieferung',
  },
  {
    value: 'partial',
    label: 'unvollständige Lieferung',
  },
];

export const OrderHistoryDelivery: RadioButtonsInputModel = {
  type: 'radioButtons',
  name: 'delivery',
  label: 'Verfügbarkeit',
  defaultValue: '',
  value: '',
  options: OrderHistoryDeliveryOptions,
};
